import adapters from '../adapter'
import services from '../service'
import HttpCacheAdapterFactory from './HttpCacheAdapterFactory'
import HttpCacheServiceFactory from './HttpCacheServiceFactory'

export const adaptorFactory = new HttpCacheAdapterFactory(adapters)
export const serviceFactory = new HttpCacheServiceFactory(services)

export default {
  adaptorFactory,
  serviceFactory,
}
